module.exports = __webpack_public_path__ + "img/Rectangle 8.42f61ad7.png";